export default __webpack_public_path__ + "static/confluence-hero-13d6119a523120cd2b7f6366c4a39991.png";